import React, { useEffect, useState } from 'react';
import { Modal, Fade, Box, Typography, Button, Backdrop, Switch, Paper, useMediaQuery } from '@mui/material';
import { API, graphqlOperation } from 'aws-amplify';
import { updateUserPreference } from '../../graphql/mutations';
import { getUserThemePreference } from '../../graphql/queries';
import { styled } from '@mui/material/styles';
import { CheckCircle } from '@mui/icons-material';
import Colour from '../../styles/Colour';
import { orange } from '@mui/material/colors';
import { fetchUserPreference } from '../../redux/reducers/UserPreference';
import { useDispatch } from 'react-redux';
import { getTheme, useThemes } from '../Theme/theme';
import { createUserPreference } from '../../graphql';
import { useFeatureFlag } from '../../features/FeatureFlag';

const MaterialUISwitch = styled(Switch)(({ themeS, checked }) => ({
  width: 62,
  height: 34,
  padding: 7,
  '& .MuiSwitch-switchBase': {
    margin: 1,
    padding: 0,
    transform: 'translateX(6px)',
    '&.Mui-checked': {
      color: '#fff',
      transform: 'translateX(22px)',
      '& .MuiSwitch-thumb:before': {
        backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 20 20"><path fill="${encodeURIComponent(
          '#fff'
        )}" d="M4.2 2.5l-.7 1.8-1.8.7 1.8.7.7 1.8.6-1.8L6.7 5l-1.9-.7-.6-1.8zm15 8.3a6.7 6.7 0 11-6.6-6.6 5.8 5.8 0 006.6 6.6z"/></svg>')`,
      },
      '& + .MuiSwitch-track': {
        opacity: 1,
        backgroundColor: checked ? '#8796A5' : '#aab4be',
      },
    },
  },
  '& .MuiSwitch-thumb': {
    backgroundColor: checked ? '#001e3c' : orange[500],
    width: 32,
    height: 32,
    '&::before': {
      content: "''",
      position: 'absolute',
      width: '100%',
      height: '100%',
      left: 0,
      top: 0,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 20 20"><path fill="${encodeURIComponent(
        '#fff'
      )}" d="M9.305 1.667V3.75h1.389V1.667h-1.39zm-4.707 1.95l-.982.982L5.09 6.072l.982-.982-1.473-1.473zm10.802 0L13.927 5.09l.982.982 1.473-1.473-.982-.982zM10 5.139a4.872 4.872 0 00-4.862 4.86A4.872 4.872 0 0010 14.862 4.872 4.872 0 0014.86 10 4.872 4.872 0 0010 5.139zm0 1.389A3.462 3.462 0 0113.471 10a3.462 3.462 0 01-3.473 3.472A3.462 3.462 0 016.527 10 3.462 3.462 0 0110 6.528zM1.665 9.305v1.39h2.083v-1.39H1.666zm14.583 0v1.39h2.084v-1.39h-2.084zM5.09 13.928L3.616 15.4l.982.982 1.473-1.473-.982-.982zm9.82 0l-.982.982 1.473 1.473.982-.982-1.473-1.473zM9.305 16.25v2.083h1.389V16.25h-1.39z"/></svg>')`,
    },
  },
  '& .MuiSwitch-track': {
    opacity: 1,
    backgroundColor: checked ? '#8796A5' : '#aab4be',
    borderRadius: 20 / 2,
  },
}));
const DarkSwitchCom = ({ darkSwtch, setDarkSwitch }) => (
  <Box
    sx={{
      // padding : "15px",
      width: '288px',
      display: 'flex',
      justifyContent: 'center',
      flexDirection: { xs: 'column', sm: 'row' },
    }}
  >
    {/* <Button variant='contained'>
                                    Dark
                                </Button> */}
    <Box
      sx={{
        width: '160px',
        display: 'flex',
        alignItems: 'center',
        // backgroundColor: '#121212',
        background: darkSwtch ? '#121212' : '#F5F3FC',
        borderRadius: '20px',
        padding: '10px 20px',
        boxShadow: '0px 10px 20px rgba(0, 0, 0, 0.2)',
      }}
    >
      <Typography color={darkSwtch ? 'white' : 'black'} sx={{ width: '45px' }}>
        {darkSwtch ? 'Dark' : 'Light'}
      </Typography>
      <Typography color={darkSwtch ? 'white' : 'black'}>Theme</Typography>
      <MaterialUISwitch
        checked={darkSwtch}
        onChange={(e) => {
          setDarkSwitch(e.target.checked);
        }}
      />
    </Box>
  </Box>
);
const CheckIcon = styled(CheckCircle)(({ clicked }) => ({
  color: 'green',
  fontSize: '24px',
  opacity: clicked ? 1 : 0,
  transition: 'opacity 0.25s ease-in-out',
  position: 'absolute',
  top: '5px', // Adjust as necessary
  right: '5px', // Adjust as necessary
}));
const ColorSelector = ({ color, isSelected, onClick, colourData }) => {
  return (
    <Box
      sx={{
        flex: 1,
        margin: '10px',
        height: '60px',
        cursor: 'pointer',
      }}
      onClick={onClick}
    >
      <Box
        sx={{
          position: 'relative',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          transition: '.25s',
          width: isSelected == 1 ? '55px' : '40px',
          height: isSelected == 1 ? '55px' : '40px',
          background: colourData.primary,
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {isSelected === true && <CheckIcon clicked={isSelected === true} />}
      </Box>
    </Box>
  );
};
const SelectTheme = ({ isOpen, onClose, setModalopen }) => {
  const { theme } = useThemes();
  const smallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const isDarkThemeEnabled = useFeatureFlag('darkmode');
  console.log({ isDarkThemeEnabled });
  let dispatch = useDispatch();
  let [sampleTheme, setSampleTm] = useState({
    primary: theme.palette.primary.main,
    secondary: theme.palette.secondary.main,
    body: theme.palette.shadow.primary,
  });
  let clt = {
    purple: theme.palette.TmId.id.toString().replace('9', '') == 3,
    dblue1: theme.palette.TmId.id.toString().replace('9', '') == 50,
    pink: theme.palette.TmId.id.toString().replace('9', '') == 1,
    green: theme.palette.TmId.id.toString().replace('9', '') == 2,
    blue: theme.palette.TmId.id.toString().replace('9', '') == 4,
    dblue: theme.palette.TmId.id.toString().replace('9', '') == 5,
    purple1: theme.palette.TmId.id.toString().replace('9', '') == 30,
    pink1: theme.palette.TmId.id.toString().replace('9', '') == 10,
    green1: theme.palette.TmId.id.toString().replace('9', '') == 20,
    blue1: theme.palette.TmId.id.toString().replace('9', '') == 40,
  };
  let [clickedTm, setClickedTm] = useState(clt);
  let [darkSwtch, setDarkSwitch] = useState(theme?.palette?.TmId.id.toString().includes('9'));
  //   const [darkSwtch, setDarkSwitch] = useState(0);

  const arrayOfObjects = [
    { label: 'purple', value: 3 },
    { label: 'purple1', value: 30 },
    { label: 'pink', value: 1 },
    { label: 'pink1', value: 10 },
    { label: 'green', value: 2 },
    { label: 'blue', value: 4 },
    { label: 'blue1', value: 40 },
    { label: 'green1', value: 20 },
    { label: 'dblue', value: 5 },
    { label: 'dblue1', value: 50 },
  ];
  useEffect(() => {
    setClickedTm(clt);
  }, [isOpen]);
  const up = async (selectedTheme) => {
    let themeId = theme.palette.TmId.id;
    //themeId = (selectedTheme === "purple" ? 3 : (selectedTheme === "pink" ? 1 : selectedTheme === "blue" ? 4 : (selectedTheme === "dblue" ? 5 : 2)))
    arrayOfObjects.map((e) => {
      if (e.label == selectedTheme) {
        themeId = e.value;
      }
    });
    API.graphql(
      graphqlOperation(createUserPreference, {
        createUserPreferenceInput: {
          attributetypecd: 'SelectedTheme',
          attributevalue: darkSwtch ? Number(`9${themeId}`) : Number(themeId.toString().replace('9', '')),
          additionalvalue: '',
        },
      })
    )
      .then((r) => {
        console.log(r, '====>response');
        if (r.data.createUserPreference.attributevalue !== theme.palette.TmId.id) {
          dispatch(fetchUserPreference());
          let color;
          for (let key in Colour) {
            if (Colour[key].tmId == (darkSwtch ? Number(`9${themeId}`) : Number(themeId.toString().replace('9', '')))) {
              color = Colour[key];
            }
          }
          localStorage.setItem('MainTheme', JSON.stringify(color));
          // Themefn(r.data.updateUserPreference.AttributeValue)
        }
      })
      .catch((e) => {
        console.log(e, 'error');
      });
  };
  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    // bgcolor: "#E6EDF5",
    boxShadow: 24,
    outline: 'none',
    width: { xs: '90%', md: '850px' },
    height: { xs: '100', md: '360px' },
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    // minWidth: "400px",
    borderRadius: '9px',
  };

  return (
    <Modal
      id="themeSelection"
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={isOpen}
      closeAfterTransition
      onClose={onClose}
    >
      <Fade in={isOpen}>
        <Paper sx={style}>
          <Box
            sx={{
              padding: '15px',
              borderRadius: '5px',
              // height:{xs:"400px",sm:'auto'},
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-around',
              width: '90%',
              height: '80%',
            }}
          >
            <Box sx={{ width: '100%', height: { sm: '93px', xs: '' }, display: 'flex', justifyContent: 'space-around' }}>
              <Box
                sx={{
                  width: { sm: '40%', xs: '100%' },
                  height: { sm: '93px', xs: '' },
                  flexShrink: 0,
                  display: 'flex',
                  justifyContent: 'space-around',
                  alignContent: 'center',
                }}
              >
                <Typography
                  sx={{
                    fontWeight: 400,
                    color: '#8181BE',
                    fontFamily: 'Inter',
                    fontSize: { sm: '25px', md: '38px' },
                    fontStyle: 'normal',
                    lineHeight: 'normal',
                    // display: { sm: "none", md: "block" }
                  }}
                >
                  Choose your preferred theme
                </Typography>
                {isDarkThemeEnabled && smallScreen ? (
                  <MaterialUISwitch
                    checked={darkSwtch}
                    onChange={(e) => {
                      setDarkSwitch(e.target.checked);
                    }}
                  />
                ) : null}
              </Box>
              <Box
                sx={{
                  display: { sm: 'flex', xs: 'none' },
                  // flexDirection:"",
                  alignItems: 'center',
                  justifyContent: 'space-around',
                  width: '350px',
                  height: '100px',
                  flexShrink: 0,
                  borderRadius: '8px',
                  background: darkSwtch ? '#121212' : '#F5F3FC',
                  transition: '0.5s all, background 0.5s ease-in-out',
                  boxShadow: `
    inset 0 0 0.5px 1px hsla(0, 0%, 100%, 0.075),
    0 0 0 1px hsla(0, 0%, 0%, 0.05),
    0 0.3px 0.4px hsla(0, 0%, 0%, 0.02),
    0 0.9px 1.5px hsla(0, 0%, 0%, 0.045),
    0 3.5px 6px hsla(0, 0%, 0%, 0.09)`,
                }}
              >
                <Box variant="contained" sx={{ flex: 1, margin: '10px', background: sampleTheme.primary, width: '50px', height: '50px' }} />
                <Box
                  variant="contained"
                  sx={{ flex: 1, margin: '10px', background: sampleTheme.secondary, width: '50px', height: '50px' }}
                />
                <Box variant="contained" sx={{ flex: 1, margin: '10px', background: sampleTheme.body, width: '50px', height: '50px' }} />
              </Box>
            </Box>

            <Box
              sx={{
                width: '100%',
                display: 'flex',
                flexDirection: { xs: 'column', sm: 'row' },
                alignItems: 'center',
                justifyContent: 'space-around',
              }}
            >
              <Box sx={{ width: { sm: '380px', xs: '100%' }, display: 'flex', alignItems: 'center' }}>
                {/* <ColorSelector
                                    isSelected={clickedTm.purple}
                                    onClick={(() => {
                                        setClickedTm({ ...clt, purple: 1 })
                                        setSampleTm({ primary: Colour.Purple.primary, secondary: Colour.Purple.secondary, body: Colour.Purple.shadow1 })
                                    })}
                                    colourData={Colour.Purple}
                                /> */}
                <ColorSelector
                  isSelected={clickedTm.pink}
                  onClick={() => {
                    setClickedTm({ ...clt, pink: 1 });
                    setSampleTm({ primary: Colour.Pink.primary, secondary: Colour.Pink.secondary, body: Colour.Pink.shadow1 });
                  }}
                  colourData={Colour.Pink}
                />
                {/* <ColorSelector
                                    isSelected={clickedTm.green}
                                    onClick={(() => {
                                        setClickedTm({ ...clt, green: 1 })
                                        setSampleTm({ primary: Colour.Green.primary, secondary: Colour.Green.secondary, body: Colour.Green.shadow1 })
                                    })}
                                    colourData={Colour.Green}
                                /> */}
                {/* <ColorSelector
                                    isSelected={clickedTm.blue}
                                    onClick={(() => {
                                        setClickedTm({ ...clt, blue: 1 })
                                        setSampleTm({ primary: Colour.Blue.primary, secondary: Colour.Blue.secondary, body: Colour.Blue.shadow1 })
                                    })}
                                    colourData={Colour.Blue}
                                /> */}
                {/* <ColorSelector
                                    isSelected={clickedTm.dblue}
                                    onClick={((event) => {
                                        event.stopPropagation()
                                        setClickedTm({ ...clt, dblue: 1 })
                                        setSampleTm({ primary: Colour.Dblue.primary, secondary: Colour.Dblue.secondary, body: Colour.Dblue.shadow1 })
                                    })}
                                    colourData={Colour.Dblue}
                                /> */}
              </Box>
              <Box>
                {isDarkThemeEnabled ? (
                  <Box>{!smallScreen ? <DarkSwitchCom darkSwtch={darkSwtch} setDarkSwitch={setDarkSwitch} /> : null}</Box>
                ) : (
                  <>
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        height: '30px',
                        width: '200px',
                        backgroundColor: 'black',
                        gap: '10px',
                        borderRadius: '10px',
                      }}
                    >
                      <Box
                        sx={{
                          width: 20,
                          height: 20,
                          backgroundImage: `url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' height='20' width='20' viewBox='0 0 20 20'><path fill='${encodeURIComponent(
                            '#fff'
                          )}' d='M4.2 2.5l-.7 1.8-1.8.7 1.8.7.7 1.8.6-1.8L6.7 5l-1.9-.7-.6-1.8zm15 8.3a6.7 6.7 0 11-6.6-6.6 5.8 5.8 0 006.6 6.6z'/></svg>")`,
                          backgroundRepeat: 'no-repeat',
                          backgroundPosition: 'center',
                          backgroundSize: 'contain',
                          backgroundColor: '#000',
                        }}
                      />
                      <Typography sx={{ color: 'white', fontSize: '12px' }}>Dark theme coming soon...</Typography>
                    </Box>
                  </>
                )}
              </Box>
            </Box>
            <Box
              sx={{
                width: '100%',

                display: 'flex',
                flexDirection: { xs: 'column', sm: 'row' },
                alignItems: 'center',
                justifyContent: 'space-around',
              }}
            >
              <Box sx={{ width: { sm: '380px', xs: '100%' }, display: 'flex', alignItems: 'center' }}>
                {/* <ColorSelector
                                    isSelected={clickedTm.purple1}
                                    onClick={(() => {
                                        setClickedTm({ ...clt, purple1: 1 })
                                        setSampleTm({ primary: Colour.Purple1.primary, secondary: Colour.Purple1.secondary, body: Colour.Purple1.shadow1 })
                                    })}
                                    colourData={Colour.Purple1}
                                /> */}
                <ColorSelector
                  isSelected={clickedTm.pink1}
                  onClick={() => {
                    setClickedTm({ ...clt, pink1: 1 });
                    setSampleTm({ primary: Colour.Pink1.primary, secondary: Colour.Pink1.secondary, body: Colour.Pink1.shadow1 });
                  }}
                  colourData={Colour.Pink1}
                />
                {/* <ColorSelector
                                    isSelected={clickedTm.green1}
                                    onClick={(() => {
                                        setClickedTm({ ...clt, green1: 1 })
                                        setSampleTm({ primary: Colour.Green1.primary, secondary: Colour.Green1.secondary, body: Colour.Green1.shadow1 })
                                    })}
                                    colourData={Colour.Green1}
                                /> */}
                {/* <ColorSelector
                                    isSelected={clickedTm.blue1}
                                    onClick={(() => {
                                        setClickedTm({ ...clt, blue1: 1 })
                                        setSampleTm({ primary: Colour.Blue1.primary, secondary: Colour.Blue1.secondary, body: Colour.Blue1.shadow1 })
                                    })}
                                    colourData={Colour.Blue1}
                                /> */}
                {/* <ColorSelector
                                    isSelected={clickedTm.dblue1}
                                    onClick={(() => {
                                        setClickedTm({ ...clt, dblue1: 1 })
                                        setSampleTm({ primary: Colour.Dblue1.primary, secondary: Colour.Dblue1.secondary, body: Colour.Dblue1.shadow1 })
                                    })}
                                    colourData={Colour.Dblue1}
                                /> */}
              </Box>
              <Box
                sx={{
                  // padding : "15px",
                  width: '288px',
                  display: 'flex',
                  justifyContent: 'space-between',
                  // flexDirection: { xs: "column", sm: "row" },
                }}
              >
                <Button onClick={onClose} variant="outlined" sx={{ flex: 1, margin: '10px', fontSize: '12px' }}>
                  Cancel
                </Button>
                <Button
                  onClick={() => {
                    let clicked;
                    for (let key in clickedTm) {
                      console.log(key, '=====> key');
                      if (clickedTm[key] === 1) {
                        clicked = key;
                      }
                    }
                    console.log(clicked, '======> clicked');
                    if (clicked) {
                      up(clicked);
                    } else {
                      for (let key in clickedTm) {
                        if (clickedTm[key] === true) {
                          let SelectedTheme = key;
                          up(SelectedTheme);
                        }
                      }
                    }
                    onClose();
                  }}
                  variant="contained"
                  sx={{ flex: 1, margin: '10px', fontSize: '12px' }}
                >
                  Ok
                </Button>
              </Box>
            </Box>
          </Box>
        </Paper>
      </Fade>
    </Modal>
  );
};
export default SelectTheme;
